var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", { attrs: { title: _vm.name } }),
      _vm._v(" "),
      _c(
        "v-form",
        { ref: "form", staticStyle: { width: "100%" } },
        [
          _c(
            "v-card",
            [
              _c("Subheader", {
                attrs: { title: "Tenant and Project Names", "no-search": "" },
              }),
              _vm._v(" "),
              _vm.isLoading
                ? _c("v-progress-linear", { attrs: { indeterminate: true } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  !_vm.isLoading
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs12: "",
                                        md6: "",
                                        "offset-md2": "",
                                        "pl-1": "",
                                        "pr-1": "",
                                      },
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Tenant Name",
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.tenantNameForm,
                                          callback: function ($$v) {
                                            _vm.tenantNameForm = $$v
                                          },
                                          expression: "tenantNameForm",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs12: "",
                                        md6: "",
                                        "offset-md2": "",
                                        "pl-1": "",
                                        "pr-1": "",
                                      },
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Project Name",
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.projectNameForm,
                                          callback: function ($$v) {
                                            _vm.projectNameForm = $$v
                                          },
                                          expression: "projectNameForm",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs12: "",
                                        md4: "",
                                        "offset-md4": "",
                                        "pl-1": "",
                                        "pr-1": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "success",
                                            block: "",
                                          },
                                          on: { click: _vm.handleSave },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-1" },
                                            [_vm._v("done")]
                                          ),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.$t("Button.Save")) +
                                              "\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }